import React, { useState } from 'react';
import { View, StyleSheet, ScrollView } from 'react-native';
import { Text } from 'react-native-paper';
import { useClient } from '../providers/ClientProvider';
import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { RootStackParams } from './Home';
import { useNav } from '../providers/NavProvider';
import { getObjectByPath } from '../services/Utils';
import { ISitee } from './ClientLanding';
import { useFocusEffect } from '@react-navigation/native';
import Header from './Header';
import { TabScreen, Tabs, TabsProvider } from 'react-native-paper-tabs';
import LogProvider from './Logs/LogProvider';

type Props = NativeStackScreenProps<RootStackParams, "PortfolioPaper">

const PortfolioPaper: React.FC<Props> = ({ route }) => {
    const { setCurrentClientShortURL, clientObj } = useClient();
    const { sitesResp, setCurrentLeafObj, currentLeafObj } = useNav();
    const [siteObj, setSiteObj] = React.useState<ISitee>(null);
    const [uniqueLists, setUniqueLists] = useState<ISitee[]>([]);

    // Recursive function to find all unique lists
    const findAllLists = (node: ISitee, collected: Map<string, ISitee>) => {
        if (node.type === 'list' && !collected.has(node.title)) {
            collected.set(node.title, node);
        }
        if (node.children) {
            node.children.forEach(child => findAllLists(child, collected));
        }
    };

    useFocusEffect(() => {
        if (sitesResp) {
            const listMap = new Map<string, ISitee>();
            findAllLists(sitesResp, listMap);
            setUniqueLists(Array.from(listMap.values()));
        }

        if (siteObj) {
            setCurrentLeafObj(siteObj);
        }
    });

    React.useEffect(() => {
        if (route.params?.clientShortURL) {
            setCurrentClientShortURL(route.params.clientShortURL);
        }
        if (sitesResp && route.params?.sitePath) {
            const tempsiteObj = getObjectByPath(decodeURIComponent(route.params.sitePath), sitesResp);
            setSiteObj(tempsiteObj);
        }
    }, [route?.params?.sitePath, sitesResp]);

    return (
        <View style={{ flex: 1, backgroundColor: '#f5f5f5' }}>
            <Header />
            <View style={styles.navWrapper}>
                {(siteObj && siteObj.title) &&
                    <View style={styles.headerBanner}>
                        <Text variant='titleLarge' style={{ color: '#fff' }} >{siteObj.title} Portfolio (Paper)</Text>
                    </View>
                }

                {uniqueLists.length > 0 ? (
                    <TabsProvider defaultIndex={0}>
                        <Tabs style={{ backgroundColor: '#fff' }} uppercase={false} showLeadingSpace={true}>
                            {uniqueLists.map((list) => (
                                <TabScreen key={list.id} label={list.title} icon="database">
                                    <View style={styles.tabContent}>
                                        <LogProvider
                                            logTitle={list.title}
                                            parentId={list.parentId}
                                            Permissions={JSON.stringify(list.permissions || []).toLowerCase()}
                                            listObj={list}
                                            sitesResp={sitesResp}
                                        />
                                    </View>
                                </TabScreen>
                            ))}
                        </Tabs>
                    </TabsProvider>
                ) : (
                    <View style={styles.emptyState}>
                        <Text variant='bodyMedium'>No lists found in this portfolio.</Text>
                    </View>
                )}
            </View>
        </View>
    );
}

const styles = StyleSheet.create({
    navWrapper: {
        flex: 1,
    },
    headerBanner: {
        backgroundColor: '#102B27',
        width: "100%",
        padding: 15,
        alignItems: 'center',
    },
    tabContent: {
        flex: 1,
        padding: 10,
    },
    emptyState: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    }
});

export default PortfolioPaper;
